import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-600',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function CategoryEntries() {
  return (
    <section className="mt-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold font-heading text-foreground-950">分类速览</h2>
        <span className="text-xs text-foreground-400">共 4 个频道</span>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {categories.map((c) => (
          <Link
            key={c.id}
            to={`/category/${c.id}`}
            className="group rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer"
          >
            <span className={`w-11 h-11 rounded-lg flex items-center justify-center ${toneMap[c.tone]}`}>
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <h3 className="mt-3 text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
              {c.name}
            </h3>
            <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{c.description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}